<template>
    <div class="App">
        <SiteHeader />
        <HeroSection />
        <TSEKonformitatSection />
        <Features />
        <PricingSection />
        <Partner />

        <Contact />
        <FAQ />

        <SiteFooter />

        <CookieConsent />
    </div>
</template>

<script>
import SiteHeader from '@/components/SiteHeader.vue';
import HeroSection from './Landingpage/HeroSection.vue';
import TSEComplianceSection from './Landingpage/TSEComplianceSection.vue';
import Solution from './Landingpage/Solution.vue';
import Credentials from './Landingpage/Credentials.vue';
import Partner from './Landingpage/Partner.vue';
import Features from './Landingpage/Features.vue';
import CTA from './Landingpage/CTA.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import PricingSection from './Landingpage/PricingSection.vue';
import Contact from './Landingpage/Contact.vue';
import FAQ from './Landingpage/FAQ.vue';
import Testimonials from './Landingpage/Testimonials.vue';
import ProblemAwareness from './Landingpage/ProblemAwareness.vue';
import ProblemSolution from './Landingpage/ProblemSolution.vue';
import CookieConsent from '@/components/CookieConsent/index.vue';
import resizeMixin from '@/mixins/resizeMixin';

export default {
    name: 'landing',
    mixins: [resizeMixin],
    components: {
        SiteHeader,
        HeroSection,
        TSEKonformitatSection: TSEComplianceSection,
        ProblemAwareness,
        ProblemSolution,
        Solution,
        Credentials,
        Partner,
        Features,
        SiteFooter,
        PricingSection,
        Contact,
        FAQ,
        CookieConsent,
    },

    data() {
        return {
            isLoggedIn: false,
            windowWidth: window.innerWidth,
        };
    },
    methods: {
        handleResize() {
            this.windowWidth = window.innerWidth;
        },
    },
    computed: {},
    mounted() {
        document.querySelectorAll('a').forEach((a) => {
            if (a.href.includes('#')) {
                a.addEventListener('click', function (e) {
                    e.preventDefault();
                    document.querySelector(a.getAttribute('href')).scrollIntoView({
                        behavior: 'smooth',
                    });
                });
            }
        });
    },
};
</script>
<style lang="scss">
body {
    width: 100%;
    min-height: 100vh;
    padding: 0;
    margin: 0;
    font-size: 18px;
    color: var(--color-text-black);
    background-color: var(--color-bg);
    letter-spacing: 0.5px;

    .App {
        position: relative;

        line-height: 1.85em;
        font-family: var(--font-outfit);

        .Wrapper {
            max-width: 1440px;
            padding: 0 40px;
            box-sizing: border-box;
            margin: 0 auto;
        }
    }
    @media (max-width: 1200px) {
        font-size: 16px;
    }
    @media (max-width: 500px) {
        font-size: 14px;
    }
}

* {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*:focus {
    outline: none;
}

ul {
    list-style: none;
    margin: 0;
    padding: 0;
}

.Column {
    display: flex;
    gap: 10px;

    > * {
        flex: 1;
    }
}
</style>
